import { useNotifications as useNotificationContext } from '../context/NotificationContext';
import { useFeatureFlag } from './useFeatureFlag';
import { NOTIFICATION_FLAGS } from '../utils/featureFlags';

export const useNotifications = () => {
  const isInfrastructureEnabled = useFeatureFlag(NOTIFICATION_FLAGS.INFRASTRUCTURE_ENABLED);

  // Return disabled state if infrastructure is not enabled
  if (!isInfrastructureEnabled) {
    return {
      bellNotifications: [],
      unreadCount: 0,
      bannerNotifications: [],
      activeBanner: null,
      markAsRead: async () => false,
      dismissNotification: async () => false,
      markAllAsRead: async () => {},
      refreshNotifications: async () => {},
      isLoading: false,
      error: null
    };
  }

  // Only call the context hook if infrastructure is enabled
  const context = useNotificationContext();
  return context;
}; 